const WISHLIST_KEY = 'wishlist';

export const getWishlist = () => {
    try {
        const wishlist = localStorage.getItem(WISHLIST_KEY);
        return wishlist ? JSON.parse(wishlist) : [];
    } catch (error) {
        console.error('Failed to read wishlist:', error);
        return [];
    }
};

export const isInWishlist = (rezdyId) => {
    const wishlist = getWishlist();

    return wishlist.includes(String(rezdyId));
};

export const addToWishlist = (rezdyId) => {
    const id = String(rezdyId);
    const wishlist = getWishlist();

    if (!wishlist.includes(id)) {
        wishlist.push(id);
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    }
    window.dispatchEvent(new Event('wishlistChanged'));
    return wishlist;
};

export const removeFromWishlist = (rezdyId) => {
    const id = String(rezdyId);
    const wishlist = getWishlist();

    const updatedWishlist = wishlist.filter(item => item !== id);

    localStorage.setItem(WISHLIST_KEY, JSON.stringify(updatedWishlist));
    window.dispatchEvent(new Event('wishlistChanged'));
    return updatedWishlist;
};

export const toggleWishlist = (rezdyId) => {

    if (isInWishlist(rezdyId)) {
        return {
            isFavorite: false,
            wishlist: removeFromWishlist(rezdyId),
        };
    }

    return {
        isFavorite: true,
        wishlist: addToWishlist(rezdyId),
    };
};